<template>
  <div v-if="!!quantities" class="quantity-available">
    <div v-if="quantities.available == 0">Sold Out</div>
    <div v-else>
      Availability
      <div class="quantity-available-container">
        <div :style="style" class="quantity-available-bar"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    quantities: { type: [Object], default: null }
  },
  computed: {
    style() {
      return (
        'width: ' +
        Math.ceil((this.quantities.available / this.quantities.total) * 5) *
          20 +
        '%;' +
        'background: ' +
        this.getColor(
          Math.ceil((this.quantities.available / this.quantities.total) * 5) / 5
        ) +
        ' ;'
      );
    }
  },
  methods: {
    getColor(value) {
      //value from 0 to 1
      var hue = (value * 120).toString(10);
      return ['hsl(', hue, ',100%,80%)'].join('');
    }
  }
};
</script>
